import pollJobStatus from './pollJobStatus';
import { queue as queueApi } from '@afosto/spooler/api/Queue';

export default async (lines, description, configuration = {}, pollConfiguration = {}) => {
  try {
    const { printerID, hubID, shouldPoll = true } = configuration ?? {};
    const isConfigured = printerID && hubID;

    if (!isConfigured) {
      return Promise.reject(new Error('No hub or printer provided!'));
    }

    const response = await queueApi.addJob({
      job: [
        {
          kind: 'print',
          api: 'v1',
          document: {
            devices: [printerID],
            lines,
          },
        },
      ],
      hub_id: hubID,
      description,
    });
    const { reference } = response?.data ?? {};

    if (!reference) {
      return Promise.reject(new Error('No job reference found!'));
    }

    if (shouldPoll) {
      return pollJobStatus(reference, 0, pollConfiguration);
    }

    return reference;
  } catch (err) {
    return Promise.reject(err);
  }
};
